module.exports = __webpack_public_path__ + "img/case.8445e182.webp";